<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useApiStore } from "@/stores/api";

const apiStore = useApiStore();
const { autoGenerateForm } = storeToRefs(apiStore);
</script>

<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-tooltip text="Settings" location="top">
        <template v-slot:activator="{ props: tooltipProps }">
          <v-btn v-bind="{ ...props, ...tooltipProps }" icon="mdi-cog" color="#FFFFFF" variant="text" />
        </template>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item>
        <v-switch
          v-model="autoGenerateForm"
          class="px-3"
          color="primary"
          label="Enable auto-generate form"
          hide-details
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped></style>
